import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef, effect } from '@angular/core';
import { PatientSessionService } from '../patient-session.service';
import {PatientTargetModel, PatientProgramModel, PatientBehaviorModel, GeneralAttachmentModel } from '../../../core/api/models';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { StaffApiService } from '../../../core/api/services/staff-api.service';
import { OfflineDataService } from '../../../core/services/offline-data.service';
import { SupervisorApiService } from '../../../core/api/services';
import { AlertService } from '../../../shared/services/alert.service';


@Component({
  selector: 'app-target-details',
  templateUrl: './target-details.component.html',
  standalone: false,
})
export class TargetDetailsComponent  {

  @Input() target?: PatientTargetModel;
  @Input() program?: PatientProgramModel | null;
  @Input() behavior?: PatientBehaviorModel | null;
  @Input() isPreview?: boolean;
  showGraph: boolean = false;
  @Output() onCloseDetails: EventEmitter<void> = new EventEmitter<void>();

  isEditingTargetNotes: boolean = false;

  isLoadingAttachments: boolean = false;
  doShowAttachmentView: boolean = false;
  targetID: number = 0;
  attachmentList: GeneralAttachmentModel[] = [];
  selectedAttachment: GeneralAttachmentModel | null = null;
  isOfflineMode: boolean = false;

  constructor(
    protected cdRef: ChangeDetectorRef,
    private patientSessionService: PatientSessionService,
    protected sanitizer: DomSanitizer,
    private supervisorApiService: SupervisorApiService,
    private staffApiService: StaffApiService,
    protected alertService: AlertService,
    private offlineDataService: OfflineDataService
  ) {
   
  }

  ngOnInit(): void {
    console.log(this.program?.Details);
    this.isOfflineMode = this.offlineDataService.isInOfflineMode();
    
    if(!this.isOfflineMode){
      this.supervisorApiService.GetTargetAttachments({
        targetID: this.target?.ID ?? 0
      }).subscribe({
        next: (results) => {
          this.attachmentList = results;
        },
        error: (error) => {
          console.error('Error loading patient instruction attachments', error);
          this.alertService.error('Failed to load patient instruction attachments');
        }
      });
    }
  }

  onSeeGraphs(): void {
    this.showGraph = true;
  }
  onHideGraph(): void {
    this.showGraph = false;
  }
  closeDetails(): void {
    this.onCloseDetails.emit();
  }

  startEditingTargetNotes(): void {
    this.isEditingTargetNotes = true;
  }

  cancelEditingTargetNotes(): void {
    this.isEditingTargetNotes = false;
  }

  saveTargetNotes(): void {
    this.staffApiService.ChangeTargetNotes({
      targetId: this.target?.ID!,
      newNotes: this.target?.TargetNotes!,
      shouldMarkAsNew: true
    }).subscribe(() => {
      this.isEditingTargetNotes = false;
    });
  }

  lastModifiedByText(): string {
    if (!this.target?.NotesLastModifiedByUserFullName || !this.target?.NotesLastModifiedDate) {
      return '';
    }
    return 'Last modified by: ' + this.target?.NotesLastModifiedByUserFullName + ' at ';
  }
  
    getImageUrl(att: GeneralAttachmentModel) : string {
      var url = 'data:'+ att.FileType +';base64,'+ att.ImageThumbnail;
      return url;
    }
  
    openAttachmentView(att: GeneralAttachmentModel) : void {
      this.doShowAttachmentView = true;
      this.selectedAttachment = att;
    }
  
    closeAttachmentView() {
      this.doShowAttachmentView = false;
      this.selectedAttachment = null;
      if(this.isOfflineMode){
        return;
      }
      this.loadAttachments();
    }
    loadAttachments(){
      if(this.isOfflineMode){
        return;
      }
      this.supervisorApiService.GetTargetAttachments({
        targetID: this.target?.ID ?? 0
      }).subscribe({
        next: (results) => {
          this.attachmentList = results;
        },
        error: (error) => {
          console.error('Error loading patient instruction attachments', error);
          this.alertService.error('Failed to load patient instruction attachments');
        }
      });
    }
}
